module.exports = __webpack_public_path__ + "img/job_logo_1024.8ba9b20d.png";